// extracted by mini-css-extract-plugin
export default {"brandPromo":"CH-z","carousel":"DH-z"};